$(document).ready(function(){
    if($('.type-page.desktop').length){
        $(function() {
            const currentPath = window.location.pathname.replace(/\/+$/, '/')
            if (!categoryBackgrounds[currentPath]) return;
            if ($('h1').length){
                const bgImage = categoryBackgrounds[currentPath];
                const $title = $('header[itemprop="headline"]');
                const $wrap = $('<div class="category-header-wrap"><div class="container"></div></div>');
                const $content = $('<div class="category-header-content"></div>');
                const $breadcrumbs = $('.breadcrumbs-wrapper').length ? $('.breadcrumbs-wrapper') : '';
                $title.wrapAll($content);
                $('.category-header-content').wrap($wrap);
                $('.category-header-wrap .container').prepend($breadcrumbs);
                $('.category-header-wrap').attr('style', 'background:rgba(0,0,0,0.2) url('+bgImage+')');
                $('.category-header-wrap').insertAfter('header');
            }
        });
    }
})